import React from 'react';

import Tabs from '@dashboard/components/mui-atoms/Tabs';
import { EmailMessageLogExpirationStatus, useEmailMessageQuery } from '@dashboard/generated/wp/platform';

import ExpiredAlert from './ExpiredAlert';
import HtmlPanel from './HtmlPanel';
import MetaData from './MetaData';
import Preview from './Preview';
import TemplateData from './TemplateData';

type Props = {
  waypointEventId: string;
};
export default function PreviewPanels({ waypointEventId }: Props) {
  const { data } = useEmailMessageQuery({ variables: { id: waypointEventId } });

  const expirationStatus = data?.EmailMessage.logExpirationStatus;
  switch (expirationStatus) {
    case EmailMessageLogExpirationStatus.HardArchived:
    case EmailMessageLogExpirationStatus.SoftArchived:
      return <ExpiredAlert />;
  }

  return (
    <Tabs
      tabs={[
        {
          label: 'Preview',
          panel: <Preview waypointEventId={waypointEventId} />,
        },
        {
          label: 'HTML',
          panel: <HtmlPanel waypointEventId={waypointEventId} />,
        },
        {
          label: 'Template data',
          panel: <TemplateData waypointEventId={waypointEventId} />,
        },
        {
          label: 'Metadata',
          panel: <MetaData waypointEventId={waypointEventId} />,
        },
      ]}
    />
  );
}
